import { Icon, Icons, LinkButton } from '@starrez/starryui'; // need to udpate to StarryUI9
import { color, Text } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { strings } from '../localization';

export const TooComplexBar = () => {
    const canView = true; // TODO: need report generator security key

    const handleOnClick = () => {
        alert('open report generator');
    };
    return (
        <TooComplexBarWrapper>
            <IconWrapper>
                <Icon Icon={Icons.Info} />
            </IconWrapper>
            <TextWrapper>
                <Text>{strings.TooComplexBar_Label_ContextText}</Text>
                {canView ? (
                    <>
                        <Text>{strings.TooComplexBar_Label_ActionText}</Text>
                        <LinkButton Caption={strings.TooComplexBar_Label_Button} OnClick={handleOnClick} />
                    </>
                ) : (
                    <Text>{strings.TooComplexBar_Label_NoActionText}</Text>
                )}
            </TextWrapper>
        </TooComplexBarWrapper>
    );
};
const IconWrapper = styled.span`
    color: ${color.Blue.B60};
`;

const TextWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
`;

const TooComplexBarWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 40px;
    gap: 11px;
`;
